import React from "react";
import Modal from "react-bootstrap/Modal";
import { useForm } from "react-hook-form";
import useEscapeKey from "utils/useEscapeKey";
const GuiEmail = (props) => {
  const { register, handleSubmit, errors } = useForm(); // initialize the hook
  let { guiemail, showModalGuiEmail, data, guiEmail } = props;
  let { showModalEmail } = guiemail;
  let { CustomerName, ChoVayId } = data;
  const onSubmit = (data) => {
    guiEmail(data);
  };

  useEscapeKey(() => {
    if (showModalEmail) {
      showModalGuiEmail();
    }
  });

  return (
    <Modal
      show={showModalEmail}
      size="modal-dialog modal-lg"
      aria-labelledby="contained-modal-title-vcenter"
      centered
      className="modal-new modal fade text-left"
    >
      <Modal.Header>
        <h4 className="modal-title  color7-bold" id="myModalLabel16">
          <span className="btn-icon-right">
          <img  src="/app-assets/images/logo-email-v2.png"/>
          </span>
          Gửi thư điện tử
        </h4>
        <button
          type="button"
          className="close-popup-new"
          onClick={showModalGuiEmail}
        >
          <img  src="/app-assets/images/icon-dong-popup-v2.png"/>
        </button>
      </Modal.Header>
      <form onSubmit={handleSubmit(onSubmit)}>
        <Modal.Body className="">
          <div className="form form-horizontal">
            <div className="form-body">
              <div className="form-body">
                <div className="form-group row">
                  <label className="col-md-2 label-control" ><span class= "font-nguoi-nhan">Người nhận :</span></label>
                  <div className="col-md-10 font-nguoi-nhan" style={{textAlign:"left"}}>{CustomerName}</div>
                  <input
                    type="hidden"
                    name={"TenNguoiNhan"}
                    value={CustomerName}
                    ref={register}

                  ></input>
                  <input
                    type="hidden"
                    name={"ChoVayID"}
                    value={ChoVayId}
                    ref={register}
                  ></input>
                </div>
                <div className={"form-group row"}>
                  <label className={"col-md-3 label-control color7-bold"}> Email nhận <span className="canh-bao-red">*</span>
                  </label>
                  <div class={"col-md-12"}>
                    <input
                      type="text"
                      className={"form-control input-sm"} 
                      placeholder="Nhập Email"
                      ref={register({
                        required: "Hãy nhập email",
                        pattern: {
                          value: /^[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,}$/i,
                          message: "Không đúng định dạng email",
                        },
                      })}
                      name="EmailNguoiNhan"
                    />
                    <span className="canh-bao-red">
                      {errors.EmailNguoiNhan && errors.EmailNguoiNhan.message}
                    </span>
                  </div>
                </div>
                <div className={"form-group row"}>
                <label className={"col-md-3 label-control color7-bold"}>Tiêu đề <span className="canh-bao-red">*</span>
                  </label>
                  <div class={"col-md-12"}>
                    <input
                      type="text"
                      className={"form-control input-sm"}   
                      placeholder="Nhập tiêu đề Email"
                      ref={register({
                        required: "Hãy nhập tiêu đề",
                      })}
                      name="TieuDe"
                    />
                    <span className="canh-bao-red">
                      {errors.TieuDe && errors.TieuDe.message}
                    </span>
                  </div>
                </div>
                <div className="form-group row">
                  <label className="col-md-3 label-control color7-bold" for="projectinput1">
                    Nội dung<span className="canh-bao-red">*</span>
                  </label>
                  <div className="col-md-12">
                    <textarea
                      rows="5"
                      className="input-sm textarea-v2 color7"
                      placeholder="Nhập nội dung Email"
                      ref={register({
                        required: "Hãy nhập nội dung",
                      })}
                      name="NoiDung"
                    ></textarea>
                    <span className="canh-bao-red">
                      {errors.NoiDung && errors.NoiDung.message}
                    </span>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </Modal.Body>
        <Modal.Footer>
        <button
            type="button"
            className="btn btn-new-main btn-closenew"
            onClick={showModalGuiEmail}
          >
            <span>
              <i className="mdi mdi-close"></i>
            </span>
            &nbsp; Đóng
          </button>

          <button type="submit" className="btn btn-new-main button-popup-submit">
            <span>

              <img  src="/app-assets/images/icon-send-v2.png"/>
            </span>
            &nbsp;  Gửi tin
          </button>
        </Modal.Footer>
      </form>
    </Modal>
  );
};
export default GuiEmail;